import { ACTIVITY_ICONS, type ActivityIcon as ActivityName } from '../../lib/activityIcons'
import { GLYPHS, type GlyphName } from '../../lib/glyphs'

interface ActivityProps { name: ActivityName; stroke?: string; accent?: string }

/** One of the mauj activity icons. Default colours suit a gold tile. */
export function ActivityIcon({ name, stroke = '#1A1206', accent = '#FFF4DC' }: ActivityProps) {
  const inner = ACTIVITY_ICONS[name].replace(/#D9961F/g, accent).replace(/currentColor/g, stroke)
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth={1.7} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" dangerouslySetInnerHTML={{ __html: inner }} />
  )
}

export function Glyph({ name, width = 1.8 }: { name: GlyphName; width?: number }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={width} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" dangerouslySetInnerHTML={{ __html: GLYPHS[name] }} />
  )
}
